export interface TmaritalStatus {
    id?: number,
    name: string,
    className: string,
    active: string,
    view: string
}

export const initialMaritalStatus: TmaritalStatus = {
    name: "",
    className: "",
    active: "",
    view: ""
}